import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SchoolCourseMap, SchoolCourses } from '@digilize/language-school/definitions';

@Injectable({
  providedIn: 'root',
})
export class SchoolCoursesApiService {
  readonly BASE_HREF = '/api/v1.0/school-courses';

  constructor(private http: HttpClient) {}

  getActiveCourses = () => this.http.get<SchoolCourses>(`${this.BASE_HREF}`);
  getCourseMap = (courseId: string) => this.http.get<SchoolCourseMap>(`${this.BASE_HREF}/${courseId}/map`);
  getCourseCertificate = (courseId: string) =>
    this.http.get(`${this.BASE_HREF}/${courseId}/certificate`, { responseType: 'blob' });
}
